import React from 'react';
import UnderHeader from '../../../shared/header/under-header';
import AdaContent from './components/ada-content';
import Head from '../../../shared/head';

const AccessibilityStatement = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">&nbsp;</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="grey-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />
            <AdaContent />                
        </>                
    )
}

export default AccessibilityStatement; 